import { render, staticRenderFns } from "./landingPageResule.vue?vue&type=template&id=841d3ee0&scoped=true"
import script from "./landingPageResule.vue?vue&type=script&lang=js"
export * from "./landingPageResule.vue?vue&type=script&lang=js"
import style0 from "./landingPageResule.vue?vue&type=style&index=0&id=841d3ee0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841d3ee0",
  null
  
)

export default component.exports